<template>
  <div class="body-div">
    <!--    top main selection menu-->

    <div class="report-calendar">
      <div class="selecting-options">

        <div
            class="tiers-btns dropdown selection-user-bar"
            v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button class="tiers-btn" data-toggle="dropdown" type="button">
            <p>
              {{ selectedTime }}
              <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-tiers">
            <li
                v-for="btn in avgOptions"
                :key="btn.id"
                @click="selectTimeFilter(btn)"
                :class="{ activedrop: selectedTimeFrame === btn.alias }"
            >
              <a>
                {{ btn.name }}
              </a>
            </li>
          </ul>
        </div>

<!--        weekends button-->
        <div
            class="tiers-btns dropdown selection-user-bar"
            v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button class="tiers-btn" data-toggle="dropdown" type="button">
            <p>
              {{ weekends?'Inc Weekends':'Ex Weekends' }}
              <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-tiers">
            <li
                @click="weekends = false"
                :class="{ activedrop: !weekends }"
            >
              <a>
                {{ 'Ex Weekends' }}
              </a>
            </li>
            <li
                @click="weekends = true"
                :class="{ activedrop: weekends }"
            >
              <a>
                {{ 'Inc Weekends' }}
              </a>
            </li>
          </ul>
        </div>

        <div
            class="tiers-btns dropdown selection-user-bar"
            v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button class="tiers-btn" data-toggle="dropdown" type="button">
            <p>
              {{ selectedLeadFilter }}
              <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-tiers">
            <li
                v-for="btn in LeadFiltersOptions"
                :key="btn.id"
                @click="selectLeadFilter(btn.alias)"
                :class="{ activedrop: selectedLeadFilter === btn.alias }"
            >
              <a>
                {{ btn.name }}
              </a>
            </li>
          </ul>
        </div>


                <div
                    class="tiers-btns dropdown selection-user-bar"
                    v-if="CheckUserPermission([1, 2, 3, 4, 12])"
                >
                  <button class="tiers-btn" data-toggle="dropdown" type="button">
                    <p>
                      {{ selectedKey.name }} <i class="fas fa-bars" aria-hidden="true"></i>
                    </p>
                  </button>
                  <ul class="dropdown-menu ul-tiers">
                    <li
                        v-for="btn in chartKeys"
                        :key="btn.key"
                        @click="selectKey(btn)"
                        :class="{ activedrop: selectedKey.key === btn.key }"
                    >
                      <a>
                        {{ btn.name }}
                      </a>
                    </li>
                  </ul>
                </div>

<!--        <div-->
<!--            class="tiers-btns dropdown selection-user-bar"-->
<!--            v-if="CheckUserPermission([1, 2, 3, 4, 12])"-->
<!--        >-->
<!--          <button class="tiers-btn" data-toggle="dropdown" type="button">-->
<!--            <p>-->
<!--              {{ selectedAvg }} <i class="fas fa-bars" aria-hidden="true"></i>-->
<!--            </p>-->
<!--          </button>-->
<!--          <ul class="dropdown-menu ul-tiers">-->
<!--            <li-->
<!--                v-for="btn in avgOptions"-->
<!--                :key="btn.id"-->
<!--                @click="selectAvg(btn)"-->
<!--                :class="{ activedrop: selectedAvgRange === btn.alias }"-->
<!--            >-->
<!--              <a>-->
<!--                {{ btn.name }}-->
<!--              </a>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->

        <div
            class="tiers-btns dropdown selection-user-bar"
            v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button data-toggle="dropdown" type="button" class="tiers-btn">
            <p>
              {{ selectedTier }} <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-tiers">
            <li
                v-for="btn in tierOptions"
                :key="btn.id"
                @click="selectTier(btn)"
                :class="{ activedrop: selectedTierOption === btn.alias }"
            >
              <a>
                {{ btn.name }}
              </a>
            </li>
          </ul>
        </div>

        <div
            class="tiers-btns dropdown selection-user-bar"
            v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button class="tiers-btn" type="button" data-toggle="dropdown">
            <p v-if="selectedUser !== null">
              {{ displayUser }} <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
            <p v-else>
              {{ "ALL USERS" }}<i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-users">
            <li
                @click="
                selectedUser = null;
                createChart();
              "
                :class="{ activedrop: selectedUser === null }"
            >
              <a>ALL</a>
            </li>
            <li
                v-for="user in usersList"
                :key="user.id"
                :class="{ activedrop: selectedUser === user.id }"
                @click="
                selectedUser = user.id;
                displayUser = user.full_name;
                createChart();
              "
            >
              <a>
                {{ user.full_name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--    end main selection menu-->

    <div class="main-chart">
      <div class="loader-report" v-if="reqMainChartData"
      >
        Generating Report - Please wait
        <img
            src="../../../../../../src/assets/svg_icons/loading_bars.svg"
        />
      </div>
      <canvas id="akg-stats-main-chart" width="1"></canvas>
      <div id="chartjs-tooltip"></div>
      <div id="chartjs-tooltip-event"></div>
    </div>
  </div>
</template>

<script>
import UsersActiveScope
  from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import UsersStatsActiveScope
  from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersStatsActiveScope";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import moment from "moment";
import apiClientCreator from "@/helpers/api/request";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.defaults.global.pointHitDetectionRadius = 1;
const chart = Chart;

// const AkgVolChartOpt = {
//   type: "bar",
//   options: {
//     tooltips: {
//       enabled: false,
//       mode: 'index',
//       position: 'nearest',
//       //Set the name of the custom function here
//       custom: customTooltips
//     },
//     layout: {
//       padding: {
//         top: 2
//       }
//     },
//     plugins: {
//       datalabels: {
//         align: "end",
//         anchor: "end",
//         offset: -5,
//
//         font: {
//           family: "Montserrat"
//         },
//         fontSize: 9,
//         color: function(context) {
//           return "#44A2D2";
//         },
//         formatter: function(value) {
//           return value === 0 ? "" : value;
//         }
//       }
//     },
//
//     maintainAspectRatio: false,
//     gradientColors: [
//       "rgba(29,140,248,0.4)",
//       "rgba(29,140,248,0.0)",
//       "rgba(29,140,248,0)"
//     ],
//     gradientStops: [1, 0.4, 0],
//     responsive: true,
//     scales: {
//       yAxes: [
//         {
//           gridLines: {
//             drawBorder: false,
//             color: "transparent",
//             zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
//           },
//           ticks: {
//             //display:false,
//             beginAtZero: true,
//             padding: 15,
//             fontColor: "transparent", //"#44A2D2",
//             fontFamily: "Montserrat",
//             fontSize: 1
//           }
//         }
//       ],
//       xAxes: [
//         {
//           id: "bar-x-axis1",
//           // barPercentage: 1.0,
//           // categoryPercentage: 0.5,
//           gridLines: {
//             drawBorder: false,
//             color: "transparent",
//             zeroLineColor: "transparent"
//           },
//           ticks: {
//             padding: 0,
//             fontColor: "#44A2D2",
//             fontFamily: "Montserrat",
//             fontSize: 10
//           }
//         }
//       ]
//     },
//     legend: {
//       position: "top",
//       align: "end",
//       labels: {
//         boxWidth: 20,
//         fontSize: 10
//         // display: false
//       },
//       onHover: function(e) {
//         e.target.style.cursor = "pointer";
//       }
//     },
//     hover: {
//       onHover: function(e) {
//         const point = this.getElementAtEvent(e);
//         if (point.length) e.target.style.cursor = "pointer";
//         else e.target.style.cursor = "default";
//       }
//     }
//   }
// };

export default {
  name: "AkgLiveStats.component",
  mixins: [UsersActiveScope, UsersStatsActiveScope, UsersPermissionCheck],
  data() {
    return {
      chart:chart,
      AkgVolChartOpt:{},
      reqMainChartData: false,

      loaderIcon: false,
      mainChartData: [],

      mainChartTabBuild: null,

      chartTimeOut: null,
      lastUpdate: null,

      statsDate: [moment().toDate(), moment().toDate()],
      usersList: [],
      selectedUser: null,
      tierOptions: [
        {
          id: 1,
          name: "ALL TIERS",
          alias: null
        },
        {
          id: 2,
          name: "TIER1",
          alias: "1"
        },
        {
          id: 3,
          name: "TIER2",
          alias: "2"
        },
        {
          id: 4,
          name: "TIER3",
          alias: "3"
        },
        {
          id: 5,
          name: "TIER4",
          alias: "4"
        }
      ],
      avgOptions: [
        {
          id: 1,
          name: "30 Days",
          alias: 30
        },
        {
          id: 2,
          name: "90 Days",
          alias: 90
        },
        {
          id: 3,
          name: "180 Days",
          alias: 180
        },
      ],
      selectedAvgRange: 10,
      selectedAvg: "AVG 90",
      weekends:false,
      selectedTierOption: null,
      expendedChartData: {},
      selectedTier: "ALL TIERS",
      LeadFiltersOptions: [
        {
          id: 1,
          name: "ALL LEADS",
          alias: "ALL"
        },
        {
          id: 2,
          name: "DUP",
          alias: "DUP"
        },
        {
          id: 3,
          name: "REG",
          alias: "REG"
        }
      ],
      selectedLeadFilter: "ALL",
      selectedLeadOption: "ALL LEADS",
      allAvgStats: {},
      allWeekendAvgStats: {},
      avgRawStats: [],
      avgWeekendsRawStats: [],
      selectedKey:{
        key:"DP",
        name:'DEP',
        color:'rgb(189,58,255)'
      },
      chartKeys: [
        {
          name:"CLIENTS",
          key:'REG',
          color:'rgb(16,152,214)'
        },
        {
          key:"NU",
          name:'NU',
          color:'rgb(124,124,124)'
        },
        {
          key:"C2C",
          name:'C2C',
          color:'rgb(26,197,26)'
        },
        {
          key:"SMS",
          name:'SMS',
          color:'rgb(26,197,26)'
        },
        {
          key:"ENDED",
          name:'END',
          color:'rgb(0,77,64)'
        },
        {
          key:"LD",
          name:'LD',
          color:'rgb(17,68,188)'
        },
        {
          key:"MERGED",
          name:'MERGE',
          color:'rgb(53,60,60)'
        },
        {
          key:"DP",
          name:'DEP',
          color:'rgb(189,58,255)'
        },
        {
          key:"CC-DEC",
          name:'CC DEC',
          color:'rgb(18,19,19)'
        },
        {
          key:"RF",
          name:'RF',
          color:'rgb(70,172,220)'
        },
        {
          key:"NR",
          name:'NR',
          color:'rgb(124,124,124)'
        },
        {
          key:"TR-ON",
          name:'TR-ON',
          color:'rgb(197,194,26)'
        },
        {
          key:"TR-LV",
          name:'TR-LIVE',
          color:'rgb(26,197,26)'
        },
        {
          key:"NA",
          name:'NA',
          color:'rgb(226,89,0)'
        },
        {
          key:"BN",
          name:'BN',
          color:'rgb(124,124,124)'
        },

        {
          key:"NI",
          name:'NI',
          color:'rgb(124,124,124)'
        },
        {
          key:"CA",
          name:'SC',
          color:'rgb(255,139,17)'
        },

      ],
      events:[],

      requestHash: null,

      canvasId:'akg-stats-main-chart',
      selectedTimeFrame:90,
      selectedTime:'90 Days',
    };
  },
  mounted() {
    this.AkgVolChartOpt =
    {
      type: "bar",
          options: {
      tooltips: {
        enabled: false,
            mode: 'index',
            position: 'nearest',
            //Set the name of the custom function here
            custom: this.customTooltips
      },
      layout: {
        padding: {
          top: 2
        }
      },
      plugins: {
        datalabels: {
          align: "end",
              anchor: "end",
              offset: -5,

              font: {
            family: "Montserrat"
          },
          fontSize: 13,
              color: function(context) {
            return "#44A2D2";
          },
          formatter: function(value) {
            return value === 0 ? "" : value;
          }
        }
      },

      maintainAspectRatio: false,
          gradientColors: [
        "rgba(29,140,248,0.4)",
        "rgba(29,140,248,0.0)",
        "rgba(29,140,248,0)"
      ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
        yAxes: [
          {
            gridLines: {
              drawBorder: false,
              color: "transparent",
              zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
            },
            ticks: {
              //display:false,
              beginAtZero: true,
              padding: 15,
              fontColor: "transparent", //"#44A2D2",
              fontFamily: "Montserrat",
              fontSize: 1
            }
          }
        ],
            xAxes: [
          {
            id: "bar-x-axis1",
            // barPercentage: 1.0,
            // categoryPercentage: 0.5,
            gridLines: {
              drawBorder: false,
              color: "transparent",
              zeroLineColor: "transparent"
            },
            ticks: {
              padding: 0,
              fontColor: "#44A2D2",
              fontFamily: "Montserrat",
              fontSize: 10
            }
          }
        ]
      },
      legend: {
        position: "top",
            align: "end",
            labels: {
          boxWidth: 20,
              fontSize: 10
          // display: false
        },
        onHover: function(e) {
          e.target.style.cursor = "pointer";
        }
      },
      hover: {
        onHover: function(e) {
          const point = this.getElementAtEvent(e);
          if (point.length) e.target.style.cursor = "pointer";
          else e.target.style.cursor = "default";
        }
      }
    }
    }

    this.usersList = this.FilterStatsNonActiveUsers(
        this.FilterNonActiveUsers()
    );
   this.fetchChartData();
  },
  watch:{
    weekends:function(){
      this.fetchChartData()
    }
  },
  methods:{

  fetchChartData(){

    this.reqMainChartData = true;
     this.requestHash = Math.floor(Math.random() * 10000) + 1;
     let queryObj = {
     };
     if (this.selectedUser) {
       queryObj = { ...queryObj, user_id: this.selectedUser };
     }
     if (this.selectedTierOption) {
       queryObj = { ...queryObj, country_tiers: [this.selectedTierOption] };
     }
     switch (this.selectedLeadFilter) {
       case "ALL":
         delete queryObj.dup_exclude;
         delete queryObj.dup;
         break;
       case "DUP":
         delete queryObj.dup_exclude;
         queryObj.dup = 1;
         break;
       case "REG":
         queryObj.dup_exclude = 1;
         delete queryObj.dup;
         break;
     }
     if(this.weekends){
       queryObj.weekend = 1;
     }
     apiClientCreator(`client/stats/akg/${this.selectedTimeFrame}`)
         .get("", {
            params: {...queryObj, hash: this.requestHash}
         })
         .then(async res => {
           if (this.requestHash === res.config.params.hash) {
             this.mainChartData = res.data;
             if (this.mainChartTabBuild) {
               this.mainChartTabBuild.destroy();
             }
             this.createChart();
             this.reqMainChartData = false;
           }
         })
         .catch(err => {
           this.reqMainChartData = false;
         });
    },

    createChart(){
    this.reqMainChartData = false;
      let stats = this.mainChartData;

     let chartOpt = this.AkgVolChartOpt;
      let opt = chartOpt.options;
      let canvasId = this.canvasId;
     let reports = stats['reports'];
     let labels = [];
     let counts = [];
     let key = this.selectedKey.key;


      try{
        this.events = [];
        reports.map(report=>{
          labels.push(report['date']);
          this.events.push(
              report['event']
          )
          let data = report['report'];
          let number = 0;

          if (data.hasOwnProperty(key)) {
            number = data[key];
            counts.push(number);
          }else{
          }
        })

      }catch (e) {
      }

      const data = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: this.selectedKey.name,
            fill: false,
            borderColor: this.selectedKey.color, //"rgba(186,231,85,0.9)",
            borderWith: 2,
            backgroundColor: "#e755ba",
            pointBackgroundColor: (context)=>{
              return this.events[context.dataIndex].length === 0 ? this.selectedKey.color : 'rgb(0,0,0)'
            },
            pointBorderColor:(context)=>{
              return this.events[context.dataIndex].length === 0 ? this.selectedKey.color : 'rgb(0,0,0)'
            },
            pointHoverBackgroundColor: this.selectedKey.color,
            pointHoverBorderColor: this.selectedKey.color,
            data: counts,
          },
        ]
      };
      if (this.mainChartTabBuild) {
        this.mainChartTabBuild.destroy();
      }
      const ctx = document.getElementById(canvasId);
      this.mainChartTabBuild = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

    },

    selectLeadFilter(filter) {
      this.selectedLeadFilter = filter;
      this.fetchChartData();
    },
    selectTier(tier) {
      this.selectedTierOption = tier.alias;
      this.selectedTier = tier.name;
      this.fetchChartData();
    },
    selectTimeFilter(time) {
      this.selectedTimeFrame = time.alias;
      this.selectedTime = time.name;
      this.fetchChartData();
    },
    selectAvg(avg) {
      this.selectedAvgRange = avg.alias;
      this.selectedAvg = avg.name;
      //this.fetchChartData();
    },
    selectKey(key) {
      this.selectedKey = key;
      this.createChart();
    },

    customTooltips(tooltip) {
      // Tooltip Element
      let tooltipEl = document.getElementById('chartjs-tooltip');
      let tooltipEl2 = document.getElementById('chartjs-tooltip-event');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        tooltipEl.innerHTML = "<table></table>"
        document.body.appendChild(tooltipEl);
      }

      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl2.style.opacity = 0;
        return;
      }
      // Set caret Position
      tooltipEl.classList.remove('above', 'below', 'no-transform');
      if (tooltip.yAlign) {
        tooltipEl.classList.add(tooltip.yAlign);
      } else {
        tooltipEl.classList.add('no-transform');
      }
      function getBody(bodyItem) {
        return bodyItem.lines;
      }
      // Set Text
      if (tooltip.body) {
        let titleLines = tooltip.title || [];
        let bodyLines = tooltip.body.map(getBody);
        //PUT CUSTOM HTML TOOLTIP CONTENT HERE (innerHTML)
        let innerHtml = '<div class="card" style="width: 18rem;">';
        innerHtml = '<div class="card-body">';
        titleLines.forEach(function(title) {
          innerHtml += '<h5 class="card-title">' + title + '</h5>';
        });
        bodyLines.forEach((body, i)=> {
          let colors = tooltip.labelColors[i];
          let style = 'background:' + colors.backgroundColor;
          style += '; border-color:' + colors.borderColor;
          style += '; border-width: 2px';
          innerHtml +=  `<p class="card-text">
          ${body}
          </p>`;

          //innerHtml += '<tr><td>' + span + body + '</td></tr>';
        });
        innerHtml += '</div>';
        innerHtml += '</div>';
        let tableRoot = tooltipEl
        tableRoot.innerHTML = innerHtml;
      }


      // let position = this._chart.canvas.getBoundingClientRect();
      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.left =  (tooltip.caretX > 1750 ? 1750 : tooltip.caretX) + 'px';
      tooltipEl.style.top = (tooltip.caretY > 750 ? 750 : tooltip.caretY) + 'px';
      // tooltipEl.style.left =  (tooltip.caretX > 1750 ? 1750 : tooltip.caretX) + 'px';
      // tooltipEl.style.top = (tooltip.caretY > 750 ? 750 : tooltip.caretY) + 'px';
      //tooltipEl.style.fontFamily = tooltip._fontFamily;
      tooltipEl.style.fontSize = tooltip.fontSize;
      tooltipEl.style.fontStyle = tooltip._fontStyle;
      tooltipEl.style.padding = 15 + 'px ' + 15 + 'px';
      tooltipEl.style.margin = 15 + 'px ' + 15 + 'px';
      if(this.events[tooltip.dataPoints[0].index].length >0){
        this.getEventHtml(tooltip)
      }
    },

    getEventHtml(tooltip){

      let tooltipEl = document.getElementById('chartjs-tooltip-event');

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-event';
        tooltipEl.innerHTML = "<table></table>"
        document.body.appendChild(tooltipEl);
      }
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }
      // Set caret Position
      tooltipEl.classList.remove('above', 'below', 'no-transform');
      if (tooltip.yAlign) {
        tooltipEl.classList.add(tooltip.yAlign);
      } else {
        tooltipEl.classList.add('no-transform');
      }
      function getBody(bodyItem) {
        return bodyItem.lines;
      }
      // Set Text
      if (tooltip.body) {
        let titleLines = tooltip.title || [];
        let bodyLines = tooltip.body.map(getBody);
        //PUT CUSTOM HTML TOOLTIP CONTENT HERE (innerHTML)
        let innerHtml = '<div class="card" style="width: 18rem;">';
        innerHtml = '<div class="card-body">';
        // titleLines.forEach(function(title) {
        //   innerHtml += '<h5 class="card-title">' + title + '</h5>';
        // });
        bodyLines.forEach((body, i)=> {
          let colors = tooltip.labelColors[i];
          let style = 'background:' + colors.backgroundColor;
          style += '; border-color:' + colors.borderColor;
          style += '; border-width: 2px';

        });

        innerHtml +=  this.events[tooltip.dataPoints[0].index][0]
        innerHtml += '</div>';
        innerHtml += '</div>';
        let tableRoot = tooltipEl
        tableRoot.innerHTML = innerHtml;
      }
      // let position = this._chart.canvas.getBoundingClientRect();
      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.left =  '50%';
      tooltipEl.style.top = '10px';
      // tooltipEl.style.left =  (tooltip.caretX > 1750 ? 1750 : tooltip.caretX) + 'px';
      // tooltipEl.style.top = (tooltip.caretY > 750 ? 750 : tooltip.caretY) + 'px';
      //tooltipEl.style.fontFamily = tooltip._fontFamily;
      tooltipEl.style.fontSize = tooltip.fontSize;
      tooltipEl.style.fontStyle = tooltip._fontStyle;
      tooltipEl.style.padding = 15 + 'px ' + 15 + 'px';
      tooltipEl.style.margin = 15 + 'px ' + 15 + 'px';
    }

  },

}
</script>

<style scoped>
#chartjs-tooltip {
  opacity: 0;
  position: absolute;
  background: rgba(0, 0, 0, .7);
  color: white;
  padding: 3px;
  border-radius: 3px;
  -webkit-transition: all .1s ease;
  transition: all .1s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  font-family: "Montserrat", Montserrat, serif;
}
.card{
  font-family: "Montserrat", Montserrat, serif;

}
#chartjs-tooltip > img {
  height: 1em;
}
#chartjs-tooltip-event {
  opacity: 0;
  position: absolute;
  background: rgb(209, 229, 231);
  color: #000000;
  padding: 3px;
  border-radius: 5px;
  -webkit-transition: all .1s ease;
  transition: all .1s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  font-family: "Montserrat", Montserrat, serif;
}

#chartjs-tooltip-event > img {
  height: 1em;
}
html * {
  text-transform: capitalize;
}
.body-div {
  /*padding: 5px 5px 1px 5px;*/
  /*padding-top: 5px;*/
  overflow-y: hidden;
  overflow-x: hidden;
  height: 90%;
  display: flex;
  flex-direction: column;
  width: 90%;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
}
.main-chart {
  min-width: 100%;
  height: 100%;
  margin: auto;
  background: white;
  border-radius: 3px;
  /*padding: 5px;*/
  position: relative;
}
.last-update-date {
  position: absolute;
  font-size: 12px;
  z-index: 1;
  right: 1px;
  top: -5px;
}
.refresh-button {
  position: absolute;
  font-size: 10px;
  z-index: 1;
  right: 100px;
  top: -5px;
  height: 18px;
}
.report-calendar {
  /*margin-top: 13px;*/
}
.selection-user-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /*height: 30px;*/
  border-radius: 0px;
}
.dropdown-menu.ul-users {
  font-size: 14px;
  overflow-y: scroll;
  max-height: 167px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 200px;
}
.dropdown-menu.ul-tiers {
  font-size: 11px;
  max-height: 225px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 73px;
}
.dropdown-menu.ul-tiers > li > a {
  padding: 3px 12px;
}
.dropdown-menu {
  border-radius: 0;
}
.activedrop {
  background-color: #efefef;
}
/*.tiers-btns{*/
/*  flex: 1;*/
/*}*/
.tiers-btn {
  border: 0px;
  border-radius: 0px;
  width: 100%;
  font-size: 10px;
  height: 15px;
}
.tiers-btn p {
  margin-bottom: 0px;
}
.tiers-btn:focus {
  outline: none;
}
.tiers-btn.active {
  background-color: #44a2d2;
  color: #fff;
}
.selecting-options {
  display: flex;
}
.loader-icon {
  display: flex;
  justify-content: center;
}
.loader-icon > span > img {
  width: 15px;
}
.loader-report{
  position: absolute;
  left: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.loader-report > img {
  height: 40px;
}
.loading-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  padding: 3rem;
  border: none;
  background-color: #fff;
}
</style>